import { func, node, string } from "prop-types";
import { forwardRef, useCallback } from "react";
import { useLocation } from "react-router-dom";

import FnrShineButton from "UI/FnrButton3/FnrShineButton";

import useUrlParams from "Utilities/Hooks/useUrlParams";

import { addLeadingSlash } from "../../Utilities/stringTransformers";

/**
 *
 * @param {object} param0
 * @param {string} param0.to
 * @returns
 */
const AppendLink = forwardRef(
  ({ to: toArg, children, onClick: onClickArg, ...rest }, ref) => {
    const { pathname: currPathname } = useLocation();
    const urlParams = useUrlParams();
    const onClick = useCallback(() => {
      const currPathnameWithoutTrailingSlash = currPathname.endsWith("/")
        ? currPathname.slice(0, -1)
        : currPathname;

      const toWithNormalizedLeadingSlash = addLeadingSlash(toArg);
      const toUrl = new URL(
        `${window.location.origin}${toWithNormalizedLeadingSlash}`
      );

      const mergedSearchParams = new URLSearchParams({
        ...Object.fromEntries(Object.entries(urlParams)),
        ...Object.fromEntries(toUrl.searchParams.entries()),
      }).toString();

      window.fnReactBus.goToUrl(
        `${currPathnameWithoutTrailingSlash}${toUrl.pathname}${
          mergedSearchParams ? "?" : ""
        }${mergedSearchParams}`
      );
      if (onClickArg) onClickArg();
    }, [currPathname, onClickArg, toArg, urlParams]);

    return (
      <FnrShineButton borderRadius={8} onClick={onClick} ref={ref} {...rest}>
        {children}
      </FnrShineButton>
    );
  }
);

AppendLink.propTypes = { to: string, children: node, onClick: func };

export default AppendLink;
